<template>
	<div class="scrollProgress" v-bind:class="'decade-'+activeDecade"><div class="scrollIndicator" v-bind:class="{'is-scrolling' : isScrolling === true }" :style="{'transform': 'translateX(' + lPos + '%)'}"></div></div>
</template>

<script>
var $ = require('jquery');
export default {
	name: "ScrollIndicator",
	props: ['rootPath','apiPath','feed','lPos','activeDecade','lastScrollY','needsResize','isScrolling'],
	data() {
		return {
			scopeThis : this,
			scrollStops : [],
			scroll : {},
			scrollGroup : null,
			scrollStart : null,
			scrollEnd : null,
			timebarFlick : null,
			decadeList : [
				'1920',
				'1930',
				'1940',
				'1950',
				'1960',
				'1970',
				'1980',
				'1990',
				'2000',
				'2010',
			],
			decadeListPS1 : [
				'1970',
				'1980',
				'1990',
				'2000',
				'2010',
			],
		};
	},
	watch: {
		// call again the method if the route changes
		$route: "fetchData",
		feed: "feedchange",
		lastScrollY: "checkScrollPos",
		needsResize: "resizeTrigger"
	},
	methods: {
		feedchange: function(){
			let scopeThis = this;
			
			this.doResize();
			setTimeout(function(){
				scopeThis.doResize();
			},100);
			setTimeout(function(){
				scopeThis.doResize();
			},500);
			setTimeout(function(){
				scopeThis.doResize();
			},1000);
		},
		resizeTrigger: function(){
			if(this.needsResize === true){
				this.doResize();
			}
		},
		checkScrollPos:function(){
			let scopeThis = this;

			// this.lastScrollY = $(window).scrollTop(); // flag remove jquery
			
			var checkpointScroll = 50;
			// if(this.feed === 'ps1'){
			// 	checkpointScroll = 0;
			// } else {
				if($(".intro").hasClass("intro")){
					checkpointScroll = $(".intro").height() * 0.4;
				}
			// }


			if (this.lastScrollY >= checkpointScroll || this.feed === 'ps1') {
				scopeThis.$parent.hPos = 'main';
			} else {
				scopeThis.$parent.hPos = 'intro';
			}

			var addAmt = 90;
			if(this.feed === 'ps1'){
				addAmt = 0;
			}

			if (this.scrollStops.length > 0) {
				var found = false;

				for (var i = this.scrollStops.length - 1; i >= 0; i--) {
					if (found === false) {
						if (this.lastScrollY + addAmt > this.scrollStops[i]) {
							found = true;
							var updateFlick = false;

							if (this.scrollGroup !== i) {
								updateFlick = true;
							}

							this.scrollGroup = i;
							this.scrollStart = this.scrollStops[i];

							if (i + 1 < this.scrollStops.length) {
								this.scrollEnd = this.scrollStops[i + 1];
							} else {
								this.scrollEnd = this.scroll.docHeight;
							}

							if(updateFlick){
								if(scopeThis.feed === 'ps1'){
									scopeThis.$parent.activeDecade = scopeThis.decadeListPS1[i];
								} else {
									scopeThis.$parent.activeDecade = scopeThis.decadeList[i];
								}
								scopeThis.$parent.needsResize = true;
								if (this.timebarFlick !== null) {
									this.timebarFlick.select(i);
								}
							}
						}
					}
				}
			} else {
				// this.doResize();
				if(scopeThis.feed === 'ps1'){
					scopeThis.$parent.activeDecade = scopeThis.decadeListPS1[0];
				} else {
					scopeThis.$parent.activeDecade = scopeThis.decadeList[0];
				}
			}
			// this.scrollGroup
			var newScrollBase = this.scrollGroup * 10;
			if(this.feed === 'ps1'){
				// console.log(newScrollBase, this.scrollGroup);
				newScrollBase = this.scrollGroup * 20;
			}
			
			var segmentPerc = ((this.lastScrollY + addAmt - this.scrollStart) / (this.scrollEnd - this.scrollStart)).toFixed(4); // console.log(newScrollBase+(segmentPerc)*10);
			// console.log(this.lastScrollY + addAmt, this.scrollStart, this.scrollEnd);
			if(this.feed === 'ps1' && this.scrollStart === null){
				scopeThis.$parent.lPos = -1;
			}
			if(typeof(this.scrollGroup) === 'undefined' || this.scrollGroup === null){
				scopeThis.$parent.lPos = -1;
				scopeThis.$parent.activeDecade = null;
			}
			// console.log(this.lastScrollY, this.scrollStart, this.scrollEnd, this.scrollStart);
			// console.log(segmentPerc);
			if (segmentPerc < 100) {
				this.scroll.percScroll = newScrollBase + segmentPerc * (100 / this.scrollStops.length); // console.log(newScrollBase,(segmentPerc),newScrollBase,(100/scrollStops.length),scroll.percScroll);

				scopeThis.$parent.lPos = this.scroll.percScroll;
			}
		},
		doResize:function(){
			var tempArray = [];
			this.$parent.needsResize = false;
			if($(".stop-1920").hasClass("single")){
				tempArray.push($(".stop-1920").first().offset().top - 90);
			}
			if($(".stop-1930").hasClass("single")){
				tempArray.push($(".stop-1930").first().offset().top - 90);
			}
			if($(".stop-1940").hasClass("single")){
				tempArray.push($(".stop-1940").first().offset().top - 90);
			}
			if($(".stop-1950").hasClass("single")){
				tempArray.push($(".stop-1950").first().offset().top - 90);
			}
			if($(".stop-1960").hasClass("single")){
				tempArray.push($(".stop-1960").first().offset().top - 90);
			}
			if($(".stop-1970").hasClass("single")){
				tempArray.push($(".stop-1970").first().offset().top - 90);
			}
			if($(".stop-1980").hasClass("single")){
				tempArray.push($(".stop-1980").first().offset().top - 90);
			}
			if($(".stop-1990").hasClass("single")){
				tempArray.push($(".stop-1990").first().offset().top - 90);
			}
			if($(".stop-2000").hasClass("single")){
				tempArray.push($(".stop-2000").first().offset().top - 90);
			}
			if($(".stop-2010").hasClass("single")){
				tempArray.push($(".stop-2010").first().offset().top - 90);
			}
			// $(".decade-sep").each(function () {
			// 	tempArray.push($(this).offset().top - 90);
			// });
			if(this.feed === 'ps1'){
				tempArray[0] = 0;
			}
			if(tempArray.length > 0){
				this.scrollStops = tempArray; // console.log(scrollStops);
			}

			this.scroll.docHeight = $(document).height();
			this.scroll.winH = $(window).height();
			this.checkScrollPos();
		}
	},
	mounted() {
		let localThis = this;
		

		this.doResize();
		// $(window).scroll(localThis.checkScrollPos); // flag remove jquery
		$(window).resize(localThis.doResize); // flag remove jquery

		// $("body").on('click',function(){
		// 	// setTimeout(doResize,400);
		// });

		window.cb = function(){
			localThis.doResize();
			// checkScrollPos();
		}

	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
.scrollProgress {
	position: fixed;
	top: 0;
	left: 0; //$padIn
	right: $padIn;
	height: 100%;
	overflow: hidden;
	pointer-events: none;
	.in-intro & {
		opacity:0;
	}
	.results-filtered & {
		left: 220px;
	}
	&.decade-null {
		opacity:0;
	}
	// @supports(pointer-events:none){
	// 	mix-blend-mode: multiply;
	// 	z-index: 9;
	// 	pointer-events: none;
	// }
}
.scrollIndicator {
	position: fixed;
	top: 0px;
	left: -3px; //$padIn
	right: $padIn;
	height:0;
	backface-visibility: hidden;
	pointer-events: none;
	z-index: -1;
	.results-filtered & {
		left: 220px;
	}
}

.decades {
	position: relative;
}
.decades .scrollProgress {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 100%;
}
.decades .scrollIndicator {
	position: absolute;
}
.scrollIndicator:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 2px;
	height: 100vh;
	background: #ffd200;
	filter:blur(0);
	transition-duration:0.4s;
	transition-property:filter, opacity;
}
@include aboveTablet {
	.is-scrolling:BEFORE {
		filter: blur(2px);
		opacity:0.8;
	}
}
</style>
